import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	LinearProgress,
} from "@mui/material";
import ColourConstants from "helpers/colourConstants";
import React from "react";
import { useTranslation } from "react-i18next";
import AddDialogStyle from "styles/application/AddDialogStyle";

// Init styled components

const AT = AddDialogStyle();

const ConfirmChangeDialog = ({
	open,
	closeHandler,
	isUpdating,
	handleChangeConfirm,
	message,
}) => {
	const { t } = useTranslation();
	const resolvedMessage = message ?? t("message.aboutToChange");
	return (
		<Dialog open={open} onClose={closeHandler}>
			{isUpdating ? <LinearProgress /> : null}
			<DialogActions>
				<AT.ConfirmButton
					onClick={handleChangeConfirm}
					variant="contained"
					sx={{
						"&.MuiButton-root:hover": {
							backgroundColor: ColourConstants.deleteDialogHover,
							color: "#ffffff",
						},
					}}
				>
					{t("action.confirm")}
				</AT.ConfirmButton>
				<AT.CancelButton
					onClick={closeHandler}
					variant="contained "
					sx={{
						"&.MuiButton-root:hover": {
							backgroundColor: ColourConstants.deleteDialogHover,
							color: "#ffffff",
						},
					}}
				>
					{t("action.cancel")}
				</AT.CancelButton>
			</DialogActions>
			<DialogContent>
				<DialogContentText>{resolvedMessage}</DialogContentText>
			</DialogContent>
		</Dialog>
	);
};

export default ConfirmChangeDialog;
